import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ScrollListener from '../scroll-listener';
import scrollParent from '../../services/scroll-parent';

class LoadMore extends Component {
  state = {
    isLoading: false,
  };

  shouldLoadMore = (position, offsetY) => {
    const end = scrollParent().scrollHeight + offsetY;
    return position >= end && this.props.hasMore && !this.props.isLoading;
  };

  handleScroll = scroll => {
    const position = scroll.scrollTop + scroll.documentHeight + this.props.threshold;
    if (this.shouldLoadMore(position, scroll.y)) {
      this.loadMore();
    }
  };

  loadMore = () => {
    const { isLoading, loadMore } = this.props;

    if (isLoading || this.state.isLoading) {
      return;
    }

    this.setState({
      isLoading: true,
    });

    Promise.resolve(loadMore(this.page)).then(() => {
      this.setState({
        isLoading: false,
      });
    });
    this.page++;
  };

  componentDidMount = () => {
    this.page = this.props.pageStart;
  };

  render = () => {
    const { element: Element, children, loader, hasMore, isLoading, ...props } = this.props;
    const passProps = _.omit(props, ['scroll', 'loadMore', 'isLoading', 'pageStart', 'threshold', 'dispatch']);

    return (
      <Element {...passProps}>
        {children}
        {hasMore && (isLoading || this.state.isLoading) && loader}
        <ScrollListener onScroll={this.handleScroll} />
      </Element>
    );
  };
}

LoadMore.propTypes = {
  element: PropTypes.string,
  children: PropTypes.node,
  loader: PropTypes.node,
  hasMore: PropTypes.bool,
  loadMore: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  pageStart: PropTypes.number,
  threshold: PropTypes.number,
};

LoadMore.defaultProps = {
  element: 'div',
  hasMore: false,
  pageStart: 2,
  threshold: 500,
};

export default LoadMore;
